export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
}

export interface User {
  id: number;
  email: string;
  name: string;
  role: UserRole;
  avatarUrl?: string;
  canSeeMontantTotal?: boolean;
  canSeeAffectations?: boolean;
  canSeeEleves?: boolean;
  canSeeEnseignants?: boolean;
  canSeeReferentiel?: boolean;
  canGenerateLinks?: boolean;
  canUseAiAssistant?: boolean;
  canSeeCalendrier?: boolean;
  canAnnulerInscription?: boolean;
  canSeeMessages?: boolean;
  canSeeTawassol?: boolean;
  canSeeDevoirs?: boolean;
  canSeeDashboardGlobal?: boolean;
  canSeeDashboardRentree?: boolean;
  canSeeDashboardRepartition?: boolean;
  canSeeDashboardAdministratif?: boolean;
  canSeeDashboardVieScolaire?: boolean;
  canSeeDashboardComptabilite?: boolean;
  canManageBibliotheque?: boolean;
  canSeeComptabilite?: boolean;
  canEditComptabilite?: boolean;
  canConfigComptabilite?: boolean;
  canSeeTableauBordComptabilite?: boolean;
  canSeeHistoriqueComptabilite?: boolean;
  canSeeDocumentsComptables?: boolean;
  canDeposerCheques?: boolean;
  canSeeDefraiements?: boolean;
  canSeeDefraiementMontants?: boolean;
  canSeeDefraiementDetails?: boolean;
  canEditClasses?: boolean;
  canEditAffectations?: boolean;
  canEditEnseignants?: boolean;
  canSaisirAbsences?: boolean;
  canSeeClassesSeances?: boolean;
  canGererAbsences?: boolean;
  canEditCalendrier?: boolean;
  canSeeAccueilPermanence?: boolean;
  canGererAlertesEleves?: boolean;
  canGererTaches?: boolean;
  profils?: ProfilRef[];
  effectivePermissions?: string[];
}

export interface ProfilRef {
  id: number;
  nom: string;
}

export interface Profil {
  id: number;
  nom: string;
  description: string;
  permissions: string[];
  nbUsers: number;
}

export interface AuthTokens {
  accessToken: string;
  expiresIn: number;
}

export interface LoginCredentials {
  email: string;
  password: string;
}
